<template>
    <div class="alarmPage">
        <!-- <ArrowButton class="btn-alarm-record" @click="toAlarmRecord">
            {{ $t('integration.alarm_record') }}
        </ArrowButton> -->
        <v-search :formContent="formContent" :SearchForm="SearchForm" :inline="true" :optareBtn="optareBtn"
            @resetFn="resetFn" @searchFn="getListFn" @confirmFn="getListFn" @addFn="addFn" @DelFn="DelFn"
            @AlarmSwitchFn="AlarmSwitchFn" />
        <div class="componentPage">
            <tablePage :tableData="tableData" :loading="loading" @delFn="delFn" @choozeTableFn="choozeTableFn"
                @detailFn="detailFn" />
            <Pagination class="pagination" :total="total" :page.sync="SearchForm.iDisplayStart"
                :limit.sync="SearchForm.iDisplayLength" @pagination="getListFn"></Pagination>
        </div>
        <AlarmDialog :isShow.sync="isShow" :title="title" :rangeArray="rangeArray" ref="alarm" />
        <!-- 详情 -->
        <DetailDialog :isShowDetail.sync="isShowDetail" :title="title" :detailObj="detailObj" :rangeArray="rangeArray"
            ref="DetailDialog" />
        <!-- 报警开关对话框 -->
        <AlarmSwitchDialog></AlarmSwitchDialog>
    </div>
</template>

<script>
import { alarmTriggerList, alarmDelete, alarmDeleteBatch, alarmTriggerDetail } from '@/api/modules/alarm.js';
import mixinForm from '@/utils/formMixins.js';
import mixinRange from '@/utils/getRange.js';
import tablePage from './Table.vue';
import AlarmDialog from './dialog/AddAlarm.vue';
import DetailDialog from './dialog/AlarmDetail.vue';
import AlarmSwitchDialog from '@/components/AlarmSwitch/AlarmSwitchDialog.vue';
import bus from '@/utils/bus';
import ArrowButton from '@/components/ArrowButton/ArrowButton.vue';
import { alarmRecord } from '@/utils/winDetail';
export default {
    mixins: [mixinForm, mixinRange],
    components: {
        tablePage,
        AlarmDialog,
        DetailDialog,
        AlarmSwitchDialog,
        ArrowButton
    },
    computed: {
        isSysAdmin() {
            const currentUser = this.$store.getters.userInfo.scope;
            return (currentUser.sysScope && currentUser.sysAdmin) || (currentUser.sysScope && !currentUser.sysAdmin);
        }
    },
    data() {
        return {
            SearchForm: {
                scopeId: null,
                name: null
                // type: '0'
            },
            formContent: [
                {
                    id: 1,
                    text: $t('public.trigger'),
                    type: 'input',
                    paramsName: 'name',
                    isChooze: false
                },
                {
                    id: 2,
                    text: 'labelTitle.Range',
                    type: 'select',
                    paramsName: 'scopeId',
                    selectParam: [],
                    isChooze: false
                }
            ],
            optareBtn: [
                {
                    id: 1,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'public.btn_new',
                    method: 'addFn'
                },
                {
                    id: 2,
                    icon: '',
                    vHas: ['delRange'],
                    text: 'buttonTitle.Delete',
                    method: 'DelFn'
                },
                {
                    id: 3,
                    icon: '',
                    text: $t('integration.alarm_switch'),
                    method: 'AlarmSwitchFn'
                }
            ],
            choozeTable: [],
            // 详情
            isShowDetail: false,
            detailObj: {}
        };
    },

    mounted() {
        // debugger
        this.getRangeFn();
        if (!this.isSysAdmin) {
            this.formContent.pop();
        }
    },
    methods: {
        getRangeFn() {
            this.getCustomerList({
                type: 1,
                tab: 1
            }).then(({ result }) => {
                this.rangeArray = result;
                if (this.$store.state.type === 2 || this.$store.state.type === 3) {
                    this.formContent[1].selectParam = result.map(item => {
                        return {
                            value: item.id,
                            label: item.name
                        };
                    });
                    this.formContent[1].selectParam.unshift({ value: null, label: 'public.please' });
                }
            });
        },
        getListFn() {
            this.loading = true;
            alarmTriggerList(this.SearchForm)
                .then(({ result, pageInfo }) => {
                    this.total = pageInfo.total;
                    this.tableData = result;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        resetFn() {
            this.SearchForm = {
                scopeName: null,
                name: null,
                iDisplayStart: 0,
                iDisplayLength: 15
            };
            this.getListFn();
        },
        addFn() {
            this.title = $t('alarm.add_trigger');
            this.isShow = true;
            this.$nextTick(() => {
                this.$refs['alarm'].resetFn();
            });
        },
        choozeTableFn(arg) {
            this.choozeTable = arg;
        },
        DelFn() {
            if (this.choozeTable.length === 0) return this.$message.warning(this.$t('public.least_one_data'));
            let flag = true;
            let ids = this.choozeTable.map(item => item.id).join(',');
            for (let item of this.choozeTable) {
                if (item.useNumber !== 0) {
                    flag = false;
                    break;
                }
            }
            if (!flag) return this.$message.error($t('integration.there_is_data_with_usage_times_other_than_0_and_cannot_be_deleted'));
            this.TODOTIPDEL({ ids }, alarmDeleteBatch);
        },
        delFn(row) {
            this.TODOTIPDEL({ id: row.id }, alarmDelete);
        },
        AlarmSwitchFn() {
            if (!this.choozeTable.length) return this.$message.warning($t('integration.please_select_at_least_one_data'));
            // for (let i = 1; i < this.choozeTable.length; i++) {
            //     if (this.choozeTable[i].scene_id !== this.choozeTable[0].scene_id) {
            //         this.$message.warning($t('integration.please_select_the_same_customer'));
            //         throw new Error($t('integration.please_select_the_same_customer'));
            //     }
            // }
            const ids = this.choozeTable.map(item => item.id);
            // 调用bus 通知报警开关dialog
            bus.$emit('alarmSwitchDialog', {
                event: this.alarmSwitch,
                triggerIds: ids,
                sceneId: this.choozeTable[0].scene_id,
                getList: this.getListFn
            });
        },
        /**
         *
         * @param {*param 选中数据id} param string
         */
        TODOTIPDEL(param, url) {
            this.$confirm(this.$t('messageTitle.DeleteToContinue'))
                .then(() => {
                    url(param).then(({ state }) => {
                        if (state.code === 200) {
                            this.getListFn();
                            this.$message.success(this.$t('public.tip_del_succ').toString());
                        }
                    });
                })
                .catch(() => { });
        },
        detailFn(row) {
            this.isShowDetail = true;
            this.title = `[${row.name}]`+$t('public.details');
            this.$nextTick(() => {
                this.$refs['DetailDialog'].resetFn();
            });
            alarmTriggerDetail(row.id).then(({ result }) => {
                this.detailObj = result;
            });
        },
        toAlarmRecord() {
            alarmRecord();
        }
    }
};
</script>

<style lang="scss" scoped>
.alarmPage {
    position: relative;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;

    .btn-alarm-record {
        width: 90px;
        position: absolute;
        right: 15px;
        top: 10px;
    }

    .componentPage {
        flex: 1;

        .pagination {
            padding-top: 0;
            padding-right: 15px !important;
            display: flex;
            align-items: center;
            justify-content: flex-end;
        }
    }
}
</style>
